import { getUserById } from "../services/UsersService";
import { useMainStore } from "../store/main.store";

export async function makeLogin(token: string, userId: string, rememberMe: boolean) {
  const store = useMainStore();
  if (rememberMe) {
    localStorage.setItem("userToken", token);
  }
  store.userToken = token;
  sessionStorage.setItem("userToken", token);
  store.setUserId(userId);
  const userData = await getUserById(userId);
  store.user = userData.data.data;
}
